module.exports = __webpack_public_path__ + "img/donghua.6db1cfeb.png";